import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import PageTitle from "../../components/common/PageTitle";
import TabbedPageCard from "../../components/common/TabbedPageCard";
import { VehiclesIcon } from "../../components/common/pageIcons";
import { AddButton } from "../../components/common/AddButton";
import VehicleFaultsTab from "./components/VehicleFaultsTab";
import VehicleHosTab from "./components/VehicleHosTab";
import VehicleTab from "./components/VehicleTab";
import PageLayout from "../../components/layout/PageLayout";
import { useAppSelector } from "../../app/hooks";
import { selectCurrentUser } from "../auth/authSlice";
import { UserRoles } from "../../constants/roles";

const VEHICLE_TAB_INDEX: Record<string, number> = {
  vehicles: 0,
  hos: 1,
  faults: 2,
};

const VehiclesPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(() => {
    const tab = searchParams.get("tab");
    return tab && tab in VEHICLE_TAB_INDEX ? VEHICLE_TAB_INDEX[tab] : 0;
  });

  const handleTabChange = (index: number) => {
    setActiveTab(index);
    if (index === 2) {
      setSearchParams({ tab: "faults" }, { replace: true });
    } else if (index === 1) {
      setSearchParams({ tab: "hos" }, { replace: true });
    } else {
      setSearchParams({}, { replace: true });
    }
  };
  const navigate = useNavigate();
  const user = useAppSelector(selectCurrentUser);
  const canCreateVehicle = user?.role === UserRoles.ADMIN;

  return (
    <PageLayout variant="fullHeight">
      <PageTitle
        title="Vehicles"
        icon={<VehiclesIcon />}
        actions={
          canCreateVehicle ? (
            <AddButton onClick={() => navigate("/vehicles/create")}>
              Add Vehicle
            </AddButton>
          ) : undefined
        }
      />
      <TabbedPageCard
        idPrefix="vehicle"
        ariaLabel="vehicle tabs"
        fullHeight
        panelSx={{ p: 2, overflow: "hidden" }}
        selectedTab={activeTab}
        onTabChange={handleTabChange}
        tabs={[
          { label: "All Vehicles", content: <VehicleTab /> },
          { label: "HOS Data", content: <VehicleHosTab /> },
          { label: "Vehicle Faults", content: <VehicleFaultsTab /> },
        ]}
      />
    </PageLayout>
  );
};

export default VehiclesPage;
